import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints, conditionalSWRKey } from 'src/utils/axios';

import { HOST_API } from 'src/config-global';

import { PageConfigValues } from './config';

// ----------------------------------------------------------------------

export interface IAPIConfig {
  /** Decimal version number returned by the backend — increment triggers a full cache bust */
  version?: number;
  authenticated_config?: {
    stripe: {
      stripe_pricing_table_id?: string;
      stripe_publishable_key?: string;
    };
  };
}

const CONFIG_URL = endpoints.config;
const options = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

/**
 * We preety much get the pages from the api we get from the config
 * Then we call the page we are on with param populate * so we get all the fields.
 * @param page
 * @returns
 */
export const useGetPageConfig = (page: PageConfigValues, locale = 'en') => {
  const { data, isLoading, error, isValidating } = useSWR(
    conditionalSWRKey(`${HOST_API}/api/${page}?populate=*&locale=${locale}`),
    fetcher,
    options
  );
  const memoizedValue = useMemo(
    () => ({
      pageConfig: data?.data || [],
      pageConfigLoading: isLoading,
      pageConfigError: error,
      pageConfigValidating: isValidating,
      pageConfigEmpty: !isLoading && !data?.data?.length,
      pageConfigMeta: (!isLoading && data?.meta) || [],
    }),
    [data, error, isLoading, isValidating]
  );
  return memoizedValue;
};

export const useGetAPIConfigs = () => {
  const { data, isLoading, error, isValidating } = useSWR(
    conditionalSWRKey(`${HOST_API + CONFIG_URL}`),
    fetcher,
    options
  );
  return useMemo(
    () => ({
      config: (data?.data as IAPIConfig) || {},
      configLoading: isLoading,
      configError: error,
      configValidating: isValidating,
      configEmpty: !isLoading && !data?.data,
      configMeta: (!isLoading && data?.meta) || [],
    }),
    [data, error, isLoading, isValidating]
  );
};
